import { ComplaintGridComponent } from './app/Complaints/complaint-grid/complaint-grid.component';
import { JurisdictionGridComponent } from './app/masters/Jurisdiction/jurisdiction-grid/jurisdiction-grid.component';
import { JurisdictionFormComponent } from './app/masters/Jurisdiction/jurisdiction-form/jurisdiction-form.component';
import { ComplaintsFormComponent } from './app/Complaints/complaints-form/complaints-form.component';
import { ComplaintsComponent } from './app/Complaints/complaints.component';
import { MaintenanceFormComponent } from './app/masters/Maintenance-office/maintenance-form/maintenance-form.component';
import { MaintenanceGridComponent } from './app/masters/Maintenance-office/maintenance-grid/maintenance-grid.component';
import { EnactmentFormComponent } from './app/masters/Enactment/enactment-form/enactment-form.component';
import { EnactmentGridComponent } from './app/masters/Enactment/enactment-grid/enactment-grid.component';
//import { ComplaintsTypeFormComponent } from './app/masters/Complaints-types/complaints-type-form/complaints-type-form.component';
//import { ComplaintsTypeGridComponent } from './app/masters/Complaints-types/complaints-type-grid/complaints-type-grid.component';
import { Routes } from '@angular/router'
import { AppComponent } from './app/khb.component';
import { RegistrationComponent } from './app/registration/registration.component';
import { LoginComponent } from './app/registration/login/login.component';
import { SignupComponent } from './app/registration/signup/signup.component';
import { UltilitiesComponent } from './app/ultilities/ultilities.component';
import { RolesComponent } from './app/ultilities/roles/roles.component';
import { RolesGridComponent } from './app/ultilities/roles/roles-grid/roles-grid.component';
import { RolesFormComponent } from './app/ultilities/roles/roles-form/roles-form.component';
import { UserComponent } from './app/ultilities/user/user.component';
import { UserGridComponent } from './app/ultilities/user/user-grid/user-grid.component';
import { UserFormComponent } from './app/ultilities/user/user-form/user-form.component';
import { ClaimsComponent } from './app/ultilities/claims/claims/claims.component';
import { ClaimGridComponent } from './app/ultilities/claims/claims/claim-grid/claim-grid.component';
import { ClaimFormComponent } from './app/ultilities/claims/claims/claim-form/claim-form.component';
import { SettingComponent } from './app/ultilities/setting/setting.component';
import { HomepageComponent } from './app/homepage/homepage.component';
import { AuthGuard } from './app/auth/auth.guard';
import { ChangePasswordComponent } from './app/ultilities/change-password/change-password.component';
import { MastersComponent } from './app/masters/masters.component';
import { DistrictGridComponent } from './app/masters/district/district-grid/district-grid.component';
import { DistrictFormComponent } from './app/masters/district/district-form/district-form.component';
import { VehicleGridComponent } from './app/ultilities/vehicle/vehicle-grid/vehicle-grid.component';
import { VehicleFormComponent } from './app/ultilities/vehicle/vehicle-form/vehicle-form.component';
import { CorrespondanceTrackingComponent } from './app/correspondance-tracking/correspondance-tracking.component';
import { CtGridComponent } from './app/correspondance-tracking/ct-grid/ct-grid.component';
import { CtFormComponent } from './app/correspondance-tracking/ct-form/ct-form.component';
import { TalukGridComponent } from './app/masters/taluk/taluk-grid/taluk-grid.component';
import { TalukFormComponent } from './app/masters/taluk/taluk-form/taluk-form.component';
import { OfficeGridComponent } from './app/ultilities/office/office-grid/office-grid.component';
import { OfficeFormComponent } from './app/ultilities/office/office-form/office-form.component';
import { FirComponent } from './app/FIR/fir.component';
import { FirFormComponent } from './app/FIR/fir-form/fir-form.component';
import { FirGridComponent } from './app/FIR/fir-grid/fir-grid.component';
import { InvestigationDocsComponent } from './app/investigation-docs/investigation-docs.component';
import { InvDocGridComponent } from './app/investigation-docs/inv-doc-grid/inv-doc-grid.component';
import { DepartmentFormComponent } from './app/masters/department/department-form/department-form.component';
import { DepartmentGridComponent } from './app/masters/department/department-grid/department-grid.component';
import { FirProceGridComponent } from './app/investigation-docs/fir-proceeding-list/fir-proce-grid/fir-proce-grid.component';
//import { FirProceFormComponent } from './app/investigation-docs/fir-proceeding-list/fir-proce-form/fir-proce-form.component';
import { ForgotPasswordComponent } from './app/registration/forgot-password/forgot-password.component';
import { InvestigationFormComponent } from './app/investigationdocs-for-investigation/investigation-form/investigation-form.component';
import { InvestigationGridComponent } from './app/investigationdocs-for-investigation/investigation-grid/investigation-grid.component';
import { DeptDocumentGridComponent } from './app/masters/dept-document/dept-document-grid/dept-document-grid.component';
import { DeptDocumentFormComponent } from './app/masters/dept-document/dept-document-form/dept-document-form.component';
import { InvestmentCreationGridComponent } from './app/investment/investment-creation-grid/investment-creation-grid.component';
import { ReportsComponent } from './app/reports/reports.component';
import { AppreportComponent } from './app/reports/appreport/appreport.component';
import { MasterAccountComponent } from './app/master-account/master-account.component';
import { MemberCreationComponent } from './app/master-account/member-creation/member-creation.component';
import { MemberCreationGridComponent } from './app/master-account/member-creation-grid/member-creation-grid.component';
import { SbAccountGridComponent } from './app/master-account/sb-account-grid/sb-account-grid.component';
import { SbAccountComponent } from './app/master-account/sb-account/sb-account.component';
import { NewDepositGridComponent } from './app/master-account/new-deposit-grid/new-deposit-grid.component';
import { NewDepositComponent } from './app/master-account/new-deposit/new-deposit.component';
import { UnicoreMastersComponent } from './app/unicore-masters/unicore-masters.component';
import { CustomerCreationGridComponent } from './app/unicore-masters/customer-creation-grid/customer-creation-grid.component';
import { CustomerCreationComponent } from './app/unicore-masters/customer-creation/customer-creation.component';
import { AgentCreationGridComponent } from './app/unicore-masters/agent-creation-grid/agent-creation-grid.component';
import { AgentCreationsComponent } from './app/unicore-masters/agent-creations/agent-creations.component';
import { ExportToMachineComponent } from './app/general-transaction/export-to-machine/export-to-machine.component';
import { ImportFromMachineComponent } from './app/general-transaction/import-from-machine/import-from-machine.component';
import { GeneralTransactionComponent } from './app/general-transaction/general-transaction.component';
import { PigmyremittanceGridComponent } from './app/general-transaction/pigmyremittance-grid/pigmyremittance-grid.component';
import { PigmyremittanceComponent } from './app/general-transaction/pigmyremittance/pigmyremittance.component';
import { ReceiptCreditGridComponent } from './app/general-transaction/recepit-credit-grid/recepit-credit-grid.component';
import { ReceiptCreditComponent } from './app/general-transaction/recepit-credit/recepit-credit.component';
import { PigmyPartpaymentComponent } from './app/general-transaction/pigmy-partpayment/pigmy-partpayment.component';
import { PigmyManualcollectionComponent } from './app/general-transaction/pigmy-manualcollection/pigmy-manualcollection.component';
import { AccountClosureComponent } from './app/master-account/account-closure/account-closure.component';
import { OthertransactionComponent } from './app/othertransaction/othertransaction.component';
import { PigmyMonthlyTransferComponent } from './app/othertransaction/pigmy-monthly-transfer/pigmy-monthly-transfer.component';
import { PigmyCreationGridComponent } from './app/master-account/pigmy-creation-grid/pigmy-creation-grid.component';
import { PigmyCreationComponent } from './app/master-account/pigmy-creation/pigmy-creation.component';
import { ScheduleReportComponent } from './app/reports/schedule-report/schedule-report.component';
import { TransactionReportComponent } from './app/reports/transaction-report/transaction-report.component';
import { VoucherReportComponent } from './app/reports/voucher-report/voucher-report.component';
import { AgentTransferFormComponent } from './app/general-transaction/agent-transfer/agent-transfer-form/agent-transfer-form.component';
import { ValidateAccountsComponent } from './app/general-transaction/validate-accounts/validate-accounts/validate-accounts.component';
import { SchemecreationComponent } from './app/chitfund/schemecreation/schemecreation.component';
import { ChitfundComponent } from './app/chitfund/chitfund.component';
// import { ChitCreationComponent } from './app/chitfund/chit-creation/chit-creation.component';
import { ChitClaimComponent } from './app/chitfund/chit-claim/chit-claim.component';
import { ChitmemberTransferComponent } from './app/chitfund/chitmember-transfer/chitmember-transfer.component';
import { ScheduleGenerateComponent } from './app/chitfund/schedule-generate/schedule-generate.component';
import { ChitReceiptComponent } from './app/chitfund/chit-receipt/chit-receipt.component';
import { MiscellaneousReceiptComponent } from './app/chitfund/miscellaneous-receipt/miscellaneous-receipt.component';
import { ChitPaymentComponent } from './app/chitfund/chit-payment/chit-payment.component';
import { ChitreportsComponent } from './app/reports/chitreports/chitreports.component';
import { HelpComponent } from './app/help/help.component';
import { VoucherSearchComponent } from './app/help/voucher-search/voucher-search.component';
import { GlTransactionComponent } from './app/reports/gl-transaction/gl-transaction.component';
import { FinancialReportComponent } from './app/reports/financial-report/financial-report.component';
import { SbIntrestCalculationComponent } from './app/othertransaction/sb-intrest-calculation/sb-intrest-calculation.component';
import { ChitCreationComponent } from './app/chitfund/chit-creation/chit-creation.component';
import { SchemeCreationGridComponent } from './app/unicore-masters/scheme-creation/scheme-creation-grid/scheme-creation-grid.component';
import { SchemeCreationFormComponent } from './app/unicore-masters/Scheme-Creation/scheme-creation-form/scheme-creation-form.component';
// var data = localStorage.getItem("accessToken");
// var defaultPage;
// if(data) defaultPage = "/home"; else defaultPage = "/login";
//canActivate : [AuthGuard],
export const appRoutes: Routes = [
    {
        path: 'home', component: HomepageComponent, canActivate: [AuthGuard],
        children: [
            { path: 'investmentcreation', component: InvestmentCreationGridComponent },


            {
                path: 'password', component: UltilitiesComponent,
                children: [{ path: '', component: ChangePasswordComponent }]
            },

            {
                path: 'password/:userId', component: UltilitiesComponent,
                children: [{ path: '', component: ChangePasswordComponent }]
            },


            {
                path: 'office', component: UltilitiesComponent,
                children: [{ path: '', component: OfficeGridComponent },
                { path: 'officeform', component: OfficeFormComponent },
                { path: 'officeform/:OfficeId/:mode', component: OfficeFormComponent }
                ]
            },

            {
                path: 'rolesgrid', component: UltilitiesComponent,
                children: [{ path: '', component: RolesGridComponent },
                { path: 'rolesform', component: RolesFormComponent },
                { path: 'rolesform/:roleId/:mode', component: RolesFormComponent }
                ]
            },



            {
                path: 'user', component: UltilitiesComponent,
                children: [{ path: '', component: UserGridComponent },
                { path: 'userform', component: UserFormComponent },
                { path: 'userform/:Id/:mode', component: UserFormComponent }
                ]
            },


            {
                path: 'claims', component: UltilitiesComponent,
                children: [{ path: '', component: ClaimGridComponent },
                { path: 'claimform/:roleId/:roleName/:disp_name', component: ClaimFormComponent }
                ]
            },

            //


            //sarita master
            {
                path: 'dept-document', component: MastersComponent,
                children: [{ path: '', component: DeptDocumentGridComponent},
                { path: 'dept-document-form', component: DeptDocumentFormComponent},
                //  { path: 'dept-document-form/:dep_Id/:mode', component: DeptDocumentFormComponent }
                { path: 'dept-document-form/:dep_Id', component: DeptDocumentFormComponent },
                ]
            },
            
            {
                path: 'enactments', component: MastersComponent,
                children: [
                    { path: '', component: EnactmentGridComponent },
                    { path: 'enactment-form', component: EnactmentFormComponent },
                    { path: 'enactment-form/:Enactment_id/:mode', component: EnactmentFormComponent }
                ]
            },
            {
                path: 'jurisdiction', component: MastersComponent,
                children: [
                    { path: '', component: JurisdictionGridComponent },
                    { path: 'jurisdiction-form', component: JurisdictionFormComponent },
                    { path: 'jurisdiction-form/:Jurt_id/:mode', component: JurisdictionFormComponent }
                ]
            },
            {
                path: 'moffice', component: MastersComponent,
                children: [{ path: '', component: MaintenanceGridComponent },
                { path: 'moffice-form', component: MaintenanceFormComponent },
                { path: 'moffice-form/:Office_id/:mode', component: MaintenanceFormComponent }
                ]
            },
            {
                path: 'Department', component: MastersComponent,
                children: [{ path: '', component: DepartmentGridComponent },
                { path: 'dep-form', component: DepartmentFormComponent },
                { path: 'dep-form/:dep_Id/:mode', component: DepartmentFormComponent }
                ]
            },


            {
                path: 'complaint', component: ComplaintsComponent,
                children: [{ path: '', component: ComplaintGridComponent },
                { path: 'complaint-form', component: ComplaintsFormComponent },
                { path: 'complaint-form/:Comp_id/:mode', component: ComplaintsFormComponent }]
            },
            {
                path: 'fir', component: FirComponent,
                children: [{ path: '', component: FirGridComponent },
                { path: 'fir-form', component: FirFormComponent },
                { path: 'fir-form/:Fir_id/:mode', component: FirFormComponent }]
            },
            {
                path: 'proceedings', component: InvestigationDocsComponent,
                children: [
                    { path: '', component: InvDocGridComponent },         
                    //{ path: 'fir-prceeding', component: InvestigationFormComponent },           
                    { path: 'fir-prceeding', component: FirProceGridComponent },
                    { path: 'fir-prceeding/:Fir_id', component: FirProceGridComponent },
                    // path: 'fir-prceeding/fir-proceeding-form', component: FirProceFormComponent }
                ]
            },


            //------Unicore------//



            {
                path: 'Reports', component: ReportsComponent,
                children: [
                    { path: '', component: AppreportComponent }                     
                    
                ]
            },


            {
                path: 'UnicoreMaster', component: UnicoreMastersComponent,
                children: [
                    { path: '', component: CustomerCreationGridComponent },                    
                    {path: 'add', component: CustomerCreationComponent }, 
                    {path: 'add/:CUSTID/:mode', component: CustomerCreationComponent }                                     
                ]
            },


            {
                path: 'UnicoreMaster1', component: UnicoreMastersComponent,
                children: [                   

                    {path: 'PigmyAgent', component: AgentCreationGridComponent },
                    {path: 'PigmyAgent/add', component: AgentCreationsComponent },
                    {path:'PigmyAgent/add/:AGENT_ID/:mode',component:AgentCreationsComponent}               
                ]
            },
         

            {
                path: 'UnicoreMaster2', component: UnicoreMastersComponent,
                children: [                   
                    { path : 'scheme-creation', component:SchemeCreationGridComponent }  ,  
                    { path : 'scheme-creation-form', component:SchemeCreationFormComponent },
                    { path : 'schemecreation/add/:GlSUB_ID/:mode', component:SchemeCreationFormComponent }                
                ]
            },
            {
                path: 'Generaltransaction', component: GeneralTransactionComponent,
                children: [
                    { path: '', component: ExportToMachineComponent } ,         
                   

                    //  {path: 'Pigmyremidence', component: PigmyremittanceGridComponent },
                    // {path: 'Pigmyremidence/add', component: PigmyremittanceComponent } ,
                    
                    // {path: 'ReceiptCredit', component: ReceiptCreditGridComponent } ,
                    // {path: 'ReceiptCredit/add', component: ReceiptCreditComponent } ,

                    // {path: 'PartPayment', component: PigmyPartpaymentComponent } ,

                    // {path: 'PigmyManualCollection', component: PigmyManualcollectionComponent } 
                ]
            },


             {
                 path: 'Generaltransaction5', component: GeneralTransactionComponent,
                 children: [
                   
                     {path: 'Import', component: ImportFromMachineComponent },

                 ]
             },

            {
                path: 'Generaltransaction1', component: GeneralTransactionComponent,
                children: [
                   

                     {path: 'Pigmyremidence', component: PigmyremittanceGridComponent },
                    {path: 'Pigmyremidence/add', component: PigmyremittanceComponent } ,
                    
                   
                ]
            },

            {
                path: 'Generaltransaction2', component: GeneralTransactionComponent,
                children: [                  

                    
                    
                    {path: 'ReceiptCredit', component: ReceiptCreditGridComponent } ,
                    {path: 'ReceiptCredit/add', component: ReceiptCreditComponent }                     
                ]
            },


          


            {
                path: 'Generaltransaction4', component: GeneralTransactionComponent,
                children: [            
                                           
                
                 {path: 'PigmyManualCollection', component: PigmyManualcollectionComponent } 
                ]
            },


            
            {
                path: 'validAccounts', component: GeneralTransactionComponent,
                children: [            
                                           
                
                 {path: '', component: ValidateAccountsComponent } 
                ]
            },



            

            {
                path: 'AgentTransfer', component: GeneralTransactionComponent,
                children: [            
                                  
                
                 {path: '', component: AgentTransferFormComponent } 
                ]
            },
          
            

             {
                path: 'MasterAccount', component: MasterAccountComponent,
                children: [
                    { path: '', component: MemberCreationGridComponent },
                    { path: 'add', component: MemberCreationComponent },                                    
                    
                ]
            },


            {
                path: 'MasterAccount1', component: MasterAccountComponent,
                children: [
                    

                    { path: 'SbAccountList', component: SbAccountGridComponent },
                    { path: 'SbAccountList/add', component: SbAccountComponent }
                                    
                    
                ]
            },


            {
                path: 'MasterAccount2', component: MasterAccountComponent,
                children: [                  

                    { path: 'DepositList', component: NewDepositGridComponent },
                    { path: 'DepositList/add', component: NewDepositComponent }                                
                    
                ]
            },

            {
                path: 'PigmyCreation', component: MasterAccountComponent,
                children: [                                      

                    { path: '', component: PigmyCreationGridComponent },
                    { path: 'add', component: PigmyCreationComponent },
                    { path: 'add/:ACCId/:mode', component: PigmyCreationComponent }                   
                    
                ]
            },        

            {
                path: 'Othertransaction', component: OthertransactionComponent,
                children: [
                    { path: 'PigmyMonthlyTransfer', component: PigmyMonthlyTransferComponent },
                                   
                    
                ]
            },
            {
                path: 'Othertransaction', component: OthertransactionComponent,
                children: [          
                                  
                    

                     {path: 'PartPayment', component: PigmyPartpaymentComponent } 
                     
                ]
            },
            {
                path: 'Othertransaction', component: OthertransactionComponent,
                children: [                                      

                    { path: 'AccountCloser', component: AccountClosureComponent }                   
                    
                ]
            },
            {
                path: '', component: OthertransactionComponent,
                children: [
                    { path: 'sb-intrest-calculation', component: SbIntrestCalculationComponent },
   
                ]
            },

            {
                path: 'schedule-report', component: ReportsComponent,
                children: [{ path: '', component: ScheduleReportComponent }]
        
            },


            {
                path: 'transaction-report', component: ReportsComponent,
                children: [{ path: '', component: TransactionReportComponent }]
        
            },
        

            {
                path: 'voucher-report', component: ReportsComponent,
                children: [{ path: '', component: VoucherReportComponent }]
        
            },


            {
                path: '', component: ReportsComponent,
                children: [{ path: 'ChitsReports', component: ChitreportsComponent }]
        
            },
             {             
                 path: '', component: ReportsComponent,
                 children: [{ path: 'gl-transaction', component: GlTransactionComponent }]
        }, 
            {             
                path: '', component: ReportsComponent,
                children: [{ path: 'financial-report', component: FinancialReportComponent }]
        
            },


            //ChitreportsComponent
            
            {
                path: '', component: ChitfundComponent,
                children: [                                      

                    { path: 'chitfunds', component: SchemecreationComponent }                   
                    
                ]
            },
            {
                path: '', component: ChitfundComponent,
                children: [                                      

                    { path: 'chitcreation', component: ChitCreationComponent }                   
                    
                ]
            },
            //  {
            //      path: '', component: ChitfundComponent,

            
            //      children: [                                      

            //          { path: 'chitcreation', component: ChitCreationComponent }                   
                    
            //      ]
            //  },

            
            {
                path: '', component: ChitfundComponent,
                children: [                                      

                    { path: 'chitclaim', component: ChitClaimComponent }                   
                    
                ]
            },

            {
                path: '', component: ChitfundComponent,
                children: [                                      

                    { path: 'chitMebertransfer', component: ChitmemberTransferComponent }                   
                    
                ]
            }, 
            
            {
                path: '', component: ChitfundComponent,
                children: [                                      

                    { path: 'schedulegenerate', component: ScheduleGenerateComponent }                   
                    
                ]
            },
            
            
            {
                path: '', component: ChitfundComponent,
                children: [                                      

                    { path: 'ChitReceipt', component: ChitReceiptComponent }                   
                    
                ]
            },
            

            {
                path: '', component: ChitfundComponent,
                children: [                                      

                    { path: 'miscellaneousreceipt', component: MiscellaneousReceiptComponent }                   
                    
                ]
            },
            

            {
                path: '', component: ChitfundComponent,
                children: [                                      

                    { path: 'chitpayment', component: ChitPaymentComponent }                   
                    
                ]
            },
                
            
            // //Voucher search
            // {
            //     path: '', component: HelpComponent,
            //     children: [{ path: 'help', component: VoucherSearchComponent }]
        
            // },


            {
                path: '', component: HelpComponent,
                children: [{ path: 'help', component: VoucherSearchComponent }]
                
            },
           
           
             //------Unicore------//
            
            








            // {
            //     path: 'proceedings', component: InvestigationDocsComponent,
            //     children: [{ path: '', component: InvDocGridComponent },
            //     { path: 'io', component: InvestigationFormComponent }
            //     //{ path: 'fir-form/:Fir_id/:mode', component: FirFormComponent }
            // ]
            // },
            
            // {
            //     path: 'Investigation', component: InvestigationDocsComponent,
            //     children: [
            //         { path: '', component: InvestigationGridComponent },                    
            //         { path: 'investigation-form', component:InvestigationFormComponent  },
            //         { path: 'Investigation/:Fir_id', component: InvestigationGridComponent  },
            //         // { path: 'fir-prceeding/fir-proceeding-form', component: FirProceFormComponent },
            //     ]
            // },

            {
                path: 'Investigation', component: InvestigationDocsComponent,
                children: [
                { path: '', component: InvestigationGridComponent },
                { path: 'investigation-form', component: InvestigationFormComponent },
                { path: 'investigation-form/:Fir_id', component: InvestigationFormComponent },
                { path: 'investigation-form/:InvDoc_Id/:mode', component: InvestigationFormComponent}]
            },
            {
                path: 'vehicle', component: UltilitiesComponent,
                children: [{ path: '', component: VehicleGridComponent }]
            },
            {
                path: 'vehicleform', component: UltilitiesComponent,
                children: [{ path: '', component: VehicleFormComponent }]
            },
            {
                path: 'correspondancetracking', component: CorrespondanceTrackingComponent,
                children: [{ path: '', component: CtGridComponent }]
            },
            {
                path: 'correspondancetracking-form', component: CorrespondanceTrackingComponent,
                children: [{ path: '', component: CtFormComponent }]
            },
            {
                path: 'signup', component: RegistrationComponent,
                children: [{ path: '', component: SignupComponent }]
            },

        ]
    },
    {
        path: 'login', component: RegistrationComponent,
        children: [{ path: '', component: LoginComponent }]
    },

  

    {
        path: 'forgot-password', component: RegistrationComponent,
        children: [{ path: '', component: ForgotPasswordComponent }]
    },


    
    
    { path: '', redirectTo: '/login', pathMatch: 'full' }
];


// WEBPACK FOOTER //
// ./src/route.ts